import { IDetalleTema } from "../../interfaces/temas";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { LoadingService } from "../../loading/loading.service";
import { inject, Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { AppState } from "../../app.state";
import { selectUsuario } from "../../states/usuario/selector";
import moment from "moment";
import { AcuerdosUtilsService } from "../../formas-envio/acuerdo/utils";

@Injectable({
  providedIn: "root",
})
export class CreateDownloadFile {
  public readonly store: Store<AppState> = inject(Store);
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));

  constructor(
    private loadingService: LoadingService,
    private utils: AcuerdosUtilsService
  ) {}
  async createHTMLTemplate(data: IDetalleTema[]) {
    this.loadingService.show();
    const encabezadoHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; background:transparent; font-size:16px; padding:1rem 0;">
      <div>${this.today()}</div> 
      <div>ArchivoUnico_${this.fileName(data[0].fechaAcuerdo)}</div>
      <div></div> 
    </div>
  `;

    const headerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: center; padding:1rem 0;">
      <img style="width: 4rem; height:4rem" src="${"../../../assets/images/logo.png"}">
      <div style="font-weight: bold; font-family:'Open Sans', sans-serif; font-size:16px;">
        Temas pendientes de reportar a Mr. B
      </div>
      <div style="font-weight:550; min-width: 100px; font-size:12px; width:150px; font-family:'Open Sans', sans-serif; font-size:16px; text-align: right;">
        ${this.fileName(data[0].fechaAcuerdo)}
      </div>
    </div>
    <div style="display: flex; justify-content: center; align-items: center; background:#917740;">
      <p style="font-size:16px; color:white;">Pendientes</p>
    </div>
  `;

    const tableHTML = `
    <table border="1" cellspacing="0" cellpadding="5" style="width: 100%;">
      <thead>
        <tr style="background-color: #000000;">
          <th style="text-align:center; font-size:16px; color:white; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding:1rem 1rem 2rem 1rem; width:min-content; " >No.</th>
          <th style="text-align:center; font-size:16px; color:white; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding:1rem 1rem 2rem 1rem; width:20%;">Nombre del asunto</th>
          <th style="text-align:center; font-size:16px; color:white; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding:1rem 1rem 2rem 1rem; width:51%;">Descripción</th>
          <th style="text-align:center; font-size:16px; color:white; overflow: hidden; text-overflow: ellipsis; padding:1rem 1rem 2rem 1rem; width:10%;" >¿Qué esperamos del TAIPÁN?</th>
          <th style="text-align:center; font-size:16px; color:white; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding:1rem 1rem 2rem 1rem; width:20%;">Documentos de soporte</th>
        </tr>
      </thead>
      <tbody>
        ${data
          .map(
            (tema, index) => `
            <tr style="background-color: ${
              this.getColor(tema.id_categoria).color
            };">
              <td style="text-align:center; padding:.5rem 1rem 1rem 1rem; margin:0; border:solid 1px #000000; vertical-align: top;">${
                index + 1
              }</td>
              <td style="padding:.5rem 1rem 1rem 1rem; margin:0; border:solid 1px #000000; vertical-align: top;">${
                this.getPermisoConfidencial(tema.categorizacion)
                  ? tema.nombreTema
                  : "Tema Confidencial"
              }</td>
              <td style="padding:.5rem 1rem 1rem 1rem; margin:0; border:solid 1px #000000; vertical-align: top;">${
                this.getPermisoConfidencial(tema.categorizacion)
                  ? this.getDescripcionTemaHtml(tema.descripcionTema_html)
                  : ""
              }</td>
              <td style=" text-align:center; padding:.5rem 1rem 1rem 1rem; margin:0; border:solid 1px #000000; vertical-align: top;">${
                this.getPermisoConfidencial(tema.categorizacion)
                  ? this.getTema(tema.tipoTema).des
                  : ""
              }</td>
              <td style="padding:.5rem 1rem 1rem 1rem; margin:0; border:solid 1px #000000; vertical-align: top;">
              ${
                this.getPermisoConfidencial(tema.categorizacion)
                  ? this.getDocumentosSoporte(tema)
                  : ""
              }
              </td>
            </tr>
          `
          )
          .join("")}
      </tbody>
    </table>
  `;

    const footerHTML = `
   <div style=" display: flex; align-items: center; justify-content: flex-start; background: transparent; margin-top: 2rem; gap: 1.5rem; ">
    <div style="display: flex; justify-content: flex-start; align-items: center; ">
        <button
            style="width:35px; height:35px; border-radius:100%; background-color:#fde5cd; border:none; margin-right: 1rem;"></button>
        <p style="font-size:1.15rem; font-weigth:500;">Temas solicitados por Mr. B.</p>
    </div>
    <div style="display: flex; justify-content: flex-start; align-items: center;">
        <button
            style="width:35px; height:35px; border-radius:100%; background-color:#d9d9d9; border:none; margin-right: 1rem;"></button>
        <p style="font-size:1.15rem; font-weigth:500;">Temas enviados a Mr. B. por correo</p>
    </div>
    <div style="display: flex; justify-content: flex-start; align-items: center;">
        <button
            style="width:35px; height:35px; border-radius:100%; background-color:#c8daf8; border:none; margin-right: 1rem;"></button>
        <p style="font-size:1.15rem; font-weigth:500;">Temas en espera de revisión de AB</p>
    </div>
</div>
  `;

    // Create a container for the HTML content
    const div = document.createElement("div");
    div.style.margin = "64px";
    div.style.padding = "64px";
    div.innerHTML = encabezadoHTML + headerHTML + tableHTML + footerHTML;
    document.body.appendChild(div);

    // Convert the HTML content to a canvas
    const create = await html2canvas(div).then((canvas) => {
      const imgWidth = 210;
      const pageHeight = 290;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      const doc = new jsPDF("p", "mm");
      let position = 0;
      const pageData = canvas.toDataURL("image/jpeg", 1.0);
      const imgData = encodeURIComponent(pageData);

      let pageCount = 1;

      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      const rightMargin = 20;
      const alignx = pdfWidth - rightMargin;
      const aligny = doc.internal.pageSize.getHeight() - 8;

      const totalPages = Math.ceil(imgHeight / pageHeight);

      if (heightLeft === 0) {
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        doc.setFontSize(10);
        doc.text(`${pageCount}/${totalPages}`, alignx, alignx);
      }

      // Draw the first page
      doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      doc.setLineWidth(5);
      doc.setDrawColor(255, 255, 255);
      doc.rect(0, 0, 210, 295);
      doc.setFontSize(10);
      doc.text(`${pageCount}/${totalPages}`, alignx, aligny);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pageCount++;
        doc.addPage();
        doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        doc.setLineWidth(5);
        doc.setDrawColor(255, 255, 255);
        doc.rect(0, 0, 210, 295);
        doc.setFontSize(10);
        doc.text(`${pageCount}/${totalPages}`, alignx, aligny);

        heightLeft -= pageHeight;
      }

      const pdfBlob = doc.output("blob");
      const blobURL = URL.createObjectURL(pdfBlob);

      const anchor = document.createElement("a");
      anchor.href = blobURL;
      anchor.style.display = "none";
      anchor.target = "_blank";
      anchor.download = `ArchivoUnico_${this.fileName(
        data[0].fechaAcuerdo
      )}.pdf`;
      anchor.click();

      setTimeout(() => {
        document.body.removeChild(div);
      }, 2000);
    });
    this.loadingService.hide();
  }

  getTema = (tipoTema: number) => {
    const temas: any = {
      1: { des: "VoBo" },
      2: { des: "Comentar" },
      3: { des: "Instrucciones" },
    };
    if (temas[tipoTema]) {
      return temas[tipoTema];
    } else {
      return "Tema no encontrado";
    }
  };
  getColor = (id_categoria: number) => {
    const temas: any = {
      1: { color: "#fde5cd" },
      2: { color: "#d9d9d9" },
      3: { color: "#c8daf8" },
    };
    if (temas[id_categoria]) {
      return temas[id_categoria];
    } else {
      return "Color no encontrado";
    }
  };

  // getPermisoConfidencial = (categorizacionTema: string): boolean => {
  //   const user = structuredClone(this.stateUser.state().usuario);
  //   return categorizacionTema in user.temas;
  // };

  getPermisoConfidencial(categorizacion: string): boolean {
    const soloLecura = this.utils.getPermisoLectura(categorizacion);
    const soloEscritura = this.utils.getPermisoEscritura(categorizacion);
    return soloLecura || (soloLecura && soloEscritura);
  }

  fileName(dateString: string): string {
    moment.locale("es");
    const utcDate = moment.utc(dateString);
    const adjustedDate = utcDate.add(1, "days");
    const localDate = adjustedDate.local();
    return localDate.format("DD-MM-YYYY");
  }

  today(): string {
    const day = new Date();
    moment.locale("es");
    const utcDate = moment.utc(day);
    const localDate = utcDate.local();
    return localDate.format("DD/MM/YY, h:mm a");
  }

  getDescripcionTemaHtml(descripcionTema: any) {
    const div = document.createElement("div");
    div.innerHTML = descripcionTema;

    // Aplica estilos globales directamente

    // Aplica estilos a los elementos internos
    const elements = div.querySelectorAll("*");
    elements.forEach((element) => {
      if (element instanceof HTMLElement) {
        if (element.tagName.toLocaleLowerCase() == "span") {
          element.style.background = "transparent";
          element.style.paddingBottom = "12px";
          element.style.lineHeight = "1.5";
          element.style.wordWrap = "break-word";
        }
      }
    });

    return div.innerHTML;
  }
  getDocumentosSoporte(tema: IDetalleTema): string {
    
    if (!tema.entradas || tema.entradas.length === 0) {
      return "";
    }

    let html = "<div>";
    tema.entradas.forEach((entrada, index) => {
      console.log("entrada", entrada.idCategorizacion);
       console.log(
         "getPermisoConfidencial",
         
       );
       if (this.getPermisoConfidencial(entrada.idCategorizacion)) {
        
          let documentoSoporte = entrada.documentoSoporte;
          documentoSoporte = documentoSoporte.replace(
            /ENVIADO\s+a\s+MRB/gi,
            '<span style="color: red;">ENVIADO</span> a MrB'
          );

          html += `<p>${index + 1}) ${documentoSoporte}</p>`;

       }
      
     
    });
    html += "</div>";

    return html;
  }
}
